import { useEffect, useState } from "react"
import { Navigate, Outlet } from "react-router-dom"
import { auth } from "../Firebase/config"
import { onAuthStateChanged, signOut } from "firebase/auth"

export const ProtectedStaffpage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // 🔹 Listen for authentication changes
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(!!user) // True if logged in, false if logged out
      setLoading(false)
    })

    return () => unsubscribe() // Cleanup listener when component unmounts
  }, [])

  if (loading) return <div>Loading...</div>

  return isAuthenticated ? <Outlet /> : <Navigate to="/Login" />
}
